module.exports = __webpack_public_path__ + "img/edit.7ed90a08.svg";